import MobilePopup from '../newPopup/mobilePopup/MobilePopup';
import * as css from './WhatsAppPricingPopup.css';
import {TShow} from '../prompotionPopup/PromotionPopup';
import {useTranslation} from 'react-i18next';
import WhatsAppCard, {DataSection} from './WhatsAppCard';
import {getStaticImage, mobileMedia} from '../../globalVariables/GlobalVariables';
import Btn from '../button/btn/Btn';
import WhatsAppTermsPopup from './WhatsAppTermsPopup';
import useShow from '../../hooks/useShow';
import CustomScrollbar from '../customScrollbar/CustomScrollbar';
import {useRef} from 'react';
import Close from '../close/Close';
import {updateAccountPermission} from '../../redux/account/accountActions';
import {useSelector} from 'react-redux';
import {RootState} from '../../redux/store.type';
// import {updateWhatsAppMessageSetting} from '../../pages/eventSettings/settingItem/settingsItemFunctions';

function WhatsAppPricingPopup({show, isBottomPosition = false}: {show: TShow, isBottomPosition?: boolean}) {
    const {t} = useTranslation('whatsapp');
    const handleClose = () => show.close();
    const icon = getStaticImage('app/mailing/whatsApp.png');
    const showTermsPopup = useShow();
    const permissions = useSelector((s: RootState) => s.account.permissions);

    const contentRef = useRef(null);
    const cssStyle = `
        top: 20px;
        inset-inline-end: 5px;
        ${mobileMedia}{
            display: none
        }
    `;

    const handleAccept = async () => {
        const whatsappIndex = permissions.findIndex(p => p.permission === 'whatsApp');
        if(whatsappIndex !== -1) {
            await updateAccountPermission('whatsApp', 1, whatsappIndex);
            // await updateWhatsAppMessageSetting(false);
        }
        show.close();
    };

    const renderContent = () => {
        return <> 
            <css.image $icon={icon}/>
            <>    
                <CustomScrollbar contentRef={contentRef} cssStyle={cssStyle} />
                <css.content ref={contentRef}>
                    <css.title>{t('title')}</css.title>
                    <css.text>{t('text')}</css.text>
                    <css.boldText>{t('boldText')}</css.boldText>
                    <css.cardGrid>
                        <WhatsAppCard
                            title={t('card1.title')}
                            smallTitle={t('illustrationMessage')}
                            note={t('card1.note')}
                        >
                            <DataSection
                                number={'18'}
                                boldText={t('pennies')}
                                regularText={t('fixedTemplate')}
                            />
                            <DataSection
                                number={'25'}
                                boldText={t('pennies')}
                                regularText={t('dynamicTemplate')}
                            />
                        </WhatsAppCard>
                        <WhatsAppCard
                            title={t('card2.title')}
                            subtitle={t('card2.subtitle')}
                            smallTitle={t('illustrationMessage')}
                            note={t('card2.note')}
                        >
                            <DataSection
                                number={'18'}
                                boldText={t('pennies')}
                                regularText={t('card2.regularText')}
                            />
                        </WhatsAppCard>
                        <WhatsAppCard
                            title={t('card3.title')}
                            subtitle={t('card3.subtitle')}
                            smallTitle={t('illustrationMessage')}
                            note={t('card3.note')}
                        >
                            <DataSection
                                number={'25'}
                                boldText={t('pennies')}
                                regularText={t('card3.regularText')}
                            />
                        </WhatsAppCard>
                    </css.cardGrid>
                </css.content>
                <css.actions>
                    <css.link onClick={showTermsPopup.open}>{t('terms')}</css.link>
                    <Btn style="whatsappPricing" onClick={handleAccept}>{t('join')}</Btn>
                </css.actions>
                {showTermsPopup.isOpen && (
                    <WhatsAppTermsPopup 
                        show={showTermsPopup}
                    />
                )}
            </> 
        </>;
    };

    if(isBottomPosition) {
        return (
            <css.bottomWrapper className={show.showClass}>
                <Close className={undefined} onClick={handleClose} />
                {renderContent()}
            </css.bottomWrapper>
        );
    }

    return (
        <css.wrapper>
            <MobilePopup
                showClass={show.showClass}
                close={handleClose}
                dataCyName={'WhatsAppPricingPopup'}
                title={''}
                list={undefined}
                forwardRef={undefined}
                TopComponent={null}
            >
                {renderContent()}
            </MobilePopup>
        </css.wrapper>
    );
}

export default WhatsAppPricingPopup; 